import React, { useMemo } from 'react'
import { pick, values } from 'lodash-es'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { Button, Modal } from '@ow/comps'
import { caseStandardSplit as caseStandardSplitApi } from '@vt/apis/lib-ex/v2/standard'
import { showNotification } from '@mantine/notifications'

const StandardSplit = function ({ children }) {
  const { tbId, selectedIds } = useTbViewStore((state) =>
    pick(state, ['tbId', 'selectedIds'])
  )

  const { tbs } = useAppEx((state) => pick(state, ['tbs']))
  const currentStandardSplitTbId = useMemo(() => {
    const obj = values(tbs).find((v) => v.tbNameId === 'caseStandardSplit')
    // 待后端完善表单tag
    return obj && obj.tbId
  }, [])

  // 指标拆分
  const onCaseStandardSplit = (caseIds) => {
    if (selectedIds.length > 100) {
      showNotification({
        title: '一次最多处理100条案件',
      })
      return
    }
    if (currentStandardSplitTbId) {
      caseStandardSplitApi(tbId, currentStandardSplitTbId, caseIds).then(() => {
        showNotification({
          title: '操作成功',
        })
      })
    } else {
      showNotification({
        title: '指标拆分表单不存在！',
      })
    }
  }

  return (
    <Modal
      // 新加
      title="提示"
      nested
      size="sm"
      trigger={selectedIds.length && children}
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={({ close }) => (
        <>
          <Button
            type="secondary"
            opacityType="sm"
            style={{ marginRight: '10px' }}
            onClick={() => {
              close()
            }}
          >
            取消
          </Button>
          <Button
            type="primary"
            onClick={() => {
              onCaseStandardSplit(selectedIds)
              close()
            }}
          >
            确定
          </Button>
        </>
      )}
    >
      <div className="text-white-400" style={{ fontSize: '14px' }}>
        <div>确定要进行指标拆分吗？</div>
      </div>
    </Modal>
  )
}

export default StandardSplit
